import script from "./ViewHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewHome.vue?vue&type=script&setup=true&lang=js"

import "./ViewHome.vue?vue&type=style&index=0&id=66b550db&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b550db"]])

export default __exports__